import styled from 'styled-components';

import { WHITE, BLACK } from '@/styles/variables.style';

export const Menu = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  transform: ${({ show }) => (show ? 'translateX(0)' : 'translateX(-100vw)')};
  transition: transform 200ms ease-in-out;
  width: 100%;
  -webkit-overflow-scrolling: touch;
`;

export const LogoContainer = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  height: 60px;

  > a {
    display: flex;
  }
`;

export const Logo = styled.img`
  height: 25px;
`;

export const Sections = styled.div`
  height: calc(100% - 128px);
  overflow-y: scroll;
  padding: 28px 20px 90px 0;

  &.footerMenu {
    height: auto;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    padding: 28px 20px 0 0;
    border-bottom: 1px ${WHITE} solid;
  }
`;

export const PlaceholderWrapper = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => direction};
`;

export const MenuOuterWrapper = styled.div`
  margin: 0;
`;

export const SectionLabel = styled.h5`
  font-size: 14px;
  margin: 0;
  text-decoration: ${({ underline }) => (underline ? 'underline' : 'none')};
  text-transform: uppercase;
  color: ${BLACK};

  &.footerMenu {
    color: ${WHITE};
  }
`;

export const Flag = styled.img`
  border: 1px solid grey;
  cursor: pointer;
  height: 24px;
  margin-top: 20px;
  width: 32px;
`;

export const TwoColumnsWrapper = styled.div`
  display: flex;
  // justify-content: space-between;
  flex-direction: column;
`;

export const SocialLinksWrapper = styled.div`
  display: flex;
  margin-top: 40px;
  margin-bottom: 40px;

  > a {
    padding-right: 30px;

    &:last-child {
      padding-right: 0;
    }
  }
`;

export const TermsLinks = styled.div`
  display: flex;
  margin-top: 40px;
`;

export const TermsLink = styled.div`
  font-size: 10px;
  letter-spacing: 0.4px;
  line-height: 12px;
  margin-left: 20px;
  text-decoration: underline;
  text-transform: uppercase;

  :first-child {
    margin-left: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/GlobalMenu/Mobile/MenuOuter.style.js